import { useEffect, useState } from 'react'
import useInterval from 'hooks/useInterval'
import { getTimeUntilEventStart } from '../../helpers/dates/Event.dates'

type UseEventStartCounterType = {
  startTime: string
  enabled?: boolean
}

export const useEventStartCounter = ({
  startTime,
  enabled,
}: UseEventStartCounterType) => {
  const [startingIn, setStartingIn] = useState<string | undefined>(
    getTimeUntilEventStart(startTime),
  )

  useEffect(() => {
    setStartingIn(getTimeUntilEventStart(startTime))
  }, [startTime])

  useInterval(
    () => {
      const now = new Date()
      const seconds = now.getUTCSeconds()

      // Recalculate on round minute
      if (seconds === 0) {
        setStartingIn(getTimeUntilEventStart(startTime))
      }
    },
    { delay: enabled && startingIn ? 1000 : null },
  )

  return startingIn
}
